import fixtureTypes from '../fixtureTypes'

const lasers = [
  {
    label: 'Laser',
    value: fixtureTypes.LASER,
    models: [
      {
        value: ':/FIXTURES/LASERS/LASER00',
        label: 'Laser00',
        asset: {
          src: 'Images/Icons/profilebuilder/3d/Lasers-Laser00.png',
          class: 'pb-properties-details-model-selection-list-preview',
        },
      },
    ],
  },
]

export default lasers
